export type SupportBotRoute =
  | "signal"
  | "status"
  | "autotrade"
  | "insurance"
  | "pitstop"
  | "techhelp"
  | "dispatcher"

export function openSupportBot(tg: TelegramWebApp | undefined, route: SupportBotRoute) {
  const botUsername = (import.meta.env.VITE_SUPPORT_BOT_USERNAME || "beephelpbot")
    .replace(/^@/, "")
    .trim()
  const url = `https://t.me/${botUsername}?start=${route}`

  if (tg?.openTelegramLink) {
    try {
      tg.openTelegramLink(url)
      return
    } catch {
      // Fall through to the browser fallback.
    }
  }

  window.open(url, "_blank", "noopener,noreferrer")?.focus()
}
